import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyleDescription = styled(Box)(
  ({ theme }) => `
  font-family: ${theme.typography.fontFamily};

  a {
    color: ${theme.palette.primary.main};
    text-decoration: underline;
  }

  img {
    max-width: 100%;
    height: auto !important;
  }
  `,
);
